import { render, staticRenderFns } from "./ListResend.vue?vue&type=template&id=36c36038&lang=pug"
import script from "./ListResend.vue?vue&type=script&lang=js"
export * from "./ListResend.vue?vue&type=script&lang=js"
import style0 from "./ListResend.vue?vue&type=style&index=0&id=36c36038&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports